import {
  Button,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Image,
  // useToast,
} from '@chakra-ui/react';
import React from 'react';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import StepThree from './StepThree';
import { FaPlay } from 'react-icons/fa';
import AltpowerLogo from '../../../../assets/Home/general/altpower_logo.png';

const InverterOffCanvas = () => {
  const [currentStep, setCurrentStep] = React.useState(1);
  const [openOffCanvas, setOpenOffCanvas] = React.useState(false);
  const [responseData, setResponseData] = React.useState(null);
  const [recProduct, setRecProduct] = React.useState(null);

  // console.log('responseData', responseData)
  // console.log('recProduct', recProduct);

  const onClose = () => {
    setOpenOffCanvas(false);
    setCurrentStep(1);
  };

  const onOpen = () => {
    setOpenOffCanvas(true);
    setCurrentStep(1);
  };

  const handleNext = () => {
    setCurrentStep((prevStep) => prevStep + 1);
  };

  const handlePrevious = () => {
    setCurrentStep((prevStep) => prevStep - 1);
  };

  return (
    <>
      <Button
        rightIcon={<FaPlay />}
        bg='green.200'
        colorScheme={'green'}
        borderRadius={'20px'}
        fontSize={'14px'}
        left={['0px', '150px']}
        onClick={onOpen}
      >
        Go ahead
      </Button>
      <Drawer
        isOpen={openOffCanvas}
        placement='right'
        onClose={onClose}
        size={currentStep === 2 ? 'md' : 'lg'}
      >
        <DrawerOverlay>
          <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader>
              <Image
                src={AltpowerLogo}
                alt='Altpower Logo'
                w={['80px', '120px']}
                h={'auto'}
                pl={8}
              />
            </DrawerHeader>
            <DrawerBody pt={5} px={12}>
              {currentStep === 1 && (
                <StepOne
                  onClose={onClose}
                  handleNext={handleNext}
                  setResponceData={setResponseData}
                />
              )}
              {currentStep === 2 && (
                <StepTwo
                  onClose={onClose}
                  nextStep={handleNext}
                  previousStep={handlePrevious}
                  data={responseData}
                  setProduct={setRecProduct}
                />
              )}
              {currentStep === 3 && (
                <StepThree
                  setCurrentStep={setCurrentStep}
                  product={recProduct}
                />
              )}
            </DrawerBody>
          </DrawerContent>
        </DrawerOverlay>
      </Drawer>
    </>
  );
};

export default InverterOffCanvas;
